import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Skeleton, Box } from "@mui/material";

const renderCells = (count) =>
    Array.from({ length: count }, (_, idx) => (
        <TableCell key={idx} align="center">
            <Skeleton className="skeleton-line" variant="rounded" />
        </TableCell>
    ));

const TableSkeletonLoader = ({ rowCount = 6 }) => {
    const rows = Array.from({ length: rowCount });

    return (
        <Box p={0} m={0}>
            {/* First Table */}
            <Table sx={{ minWidth: 650 }} aria-label="simple table" className="table-view-scaleton-loader">
                <TableHead sx={{ background: "#606060", opacity: "0.4" }} className="table-head">
                    <TableRow sx={{ border: "1px solid #FFFFFF" }}>
                        <TableCell sx={{ width: "15%" }} align="center"><Skeleton className="skeleton-line" variant="rounded"></Skeleton></TableCell>
                        <TableCell sx={{ width: "70%" }} align="center"><Skeleton className="skeleton-line" variant="rounded"></Skeleton></TableCell>
                        <TableCell sx={{ width: "15%" }} align="center"><Skeleton className="skeleton-line" variant="rounded"></Skeleton></TableCell>
                    </TableRow>
                </TableHead>
            </Table>

            {/* Second Table */}
            <Table sx={{ minWidth: 650 }} className="table-view-scaleton-loader">
                <TableHead sx={{ background: "#01A4EF", opacity: "0.3" }} className="table-head">
                    <TableRow sx={{ border: "1px solid #FFFFFF" }}>
                        {renderCells(10)}
                    </TableRow>
                </TableHead>
                <TableBody className="table-body">
                    {rows.map((_, rowIndex) => (
                        <TableRow key={rowIndex}>{renderCells(10)}</TableRow>
                    ))}
                </TableBody>
            </Table>

            {/* Third Table */}
            <Table sx={{ minWidth: 650 }} className="table-view-scaleton-loader">
                <TableHead sx={{ background: "#01A4EF", opacity: "0.3" }} className="table-head">
                    <TableRow sx={{ border: "1px solid #FFFFFF" }}>
                        {renderCells(9)}
                    </TableRow>
                </TableHead>
            </Table>
        </Box>
    );
};

export default TableSkeletonLoader;
